export type Translatable = AtLeastOne<{
  [K in LanguageType]?: string;
}>;

export const LANGUAGE_TYPE = {
  English: 'en',
  French: 'fr',
} as const;

export type LanguageType = ObjectValues<typeof LANGUAGE_TYPE>; 